<template>
  <div>
    <div class="google-map" ref="googleMap" style="height: 600px;"></div>
    <template v-if="Boolean(this.google) && Boolean(this.map) && Boolean(this.markers)">
      <slot
        :google="google"
        :map="map"
        :markers="markers"
      />
    </template>
  </div>
</template>

<script>
// Original Google Map flight path curved bezier polyline code from mica's fiddle on jsfiddle.net:
// http://jsfiddle.net/mica/5o3w63uv/4/
// https://github.com/googlearchive/js-marker-clusterer
// https://cloud.google.com/blog/products/maps-platform/how-cluster-map-markers

// Fork from this example:
// http://jsfiddle.net/victorzn23/xsen0rma/4/

import GoogleMapsApiLoader from 'google-maps-api-loader'
// import MarkerClusterer from 'node-js-marker-clusterer'
import { POINT_MARKER_ICON_CONFIG, COLORS } from './settings/mapSettings'

export default {
  props: {
    mapConfig: Object,
    apiKey: String,
    markers: Array
  },
  data () {
    return {
      google: null,
      map: null,
      cluster: null,
      locations: null
    }
  },
  async mounted () {
    const googleMapApi = await GoogleMapsApiLoader({
      libraries: ['geometry', 'places'],
      apiKey: this.apiKey
    })
    this.google = googleMapApi
    this.initializeMap()
    this.centerMap()
  },
  beforeUpdate () {
    this.centerMap()
  },
  methods: {
    initializeMap () {
      const mapContainer = this.$refs.googleMap
      // const options = {
      //   imagePath: `${location.origin}/img/map/m`,
      //   maxZoom: 10
      // }
      this.map = new this.google.maps.Map(mapContainer, this.mapConfig)
      // this.markers2 = this.addMarkers(this.markers)
      // this.cluster = new MarkerClusterer(this.map, this.markers2, options)
      // const styles = this.cluster.getStyles()
      // for (let i = 0; i < styles.length; i++) {
      //   styles[i].textColor = 'white'
      //   styles[i].textSize = 14
      // }
    },
    centerMap () {
      var bounds = new this.google.maps.LatLngBounds()
      this.markers.forEach(marker => {
        bounds.extend(marker.position)
      })
      this.map.panToBounds(bounds)
      this.map.fitBounds(bounds)
    },
    addMarkers (markers) {
      return markers.map(m => {
        const MARKER_LABEL = {
          color: COLORS.MARKER_TEXT,
          fontSize: '13px',
          fontWeight: 'bold',
          text: String(m.duration)
        }
        return new this.google.maps.Marker({
          position: m.position,
          label: MARKER_LABEL,
          icon: POINT_MARKER_ICON_CONFIG,
          title: `${String(m.order)}: ${String(m.name)} (Days: ${m.startday})`
        })
      })
    }
  }
}
</script>

<style scoped>
.google-map {
  width: 100%;
  min-height: 100%;
  position: relative;
}
</style>
